import { FC, ReactNode } from 'react'

import styles from 'components/features/rewards/rewardPage/WaysToEarn/WaysToEarnBenefit.styl'

type WaysToEarnBenefitProps = {
  benefitLabelNode: ReactNode
  benefitButtonNode: ReactNode | null
}

export const WaysToEarnBenefit: FC<WaysToEarnBenefitProps> = ({
  benefitLabelNode,
  benefitButtonNode,
}) => {
  return (
    <div className={ styles.container }>
      { benefitButtonNode }
      { benefitLabelNode }
    </div>
  )
}
